import React, { Component } from 'react';
import _ from 'lodash';
import { AutoSizer } from 'react-virtualized';
import { Tooltip, Input } from 'antd';
import DatePicker from 'react-datepicker';
import moment from 'moment';

import 'react-datepicker/dist/react-datepicker.css';
import 'react-virtualized/styles.css';

import VirtualRow from './VirtualRow';
import SummaryRow from './SummaryRow';
import SummaryRowByYear from './SummaryRowByYear';

class EditableCell extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: ''
        }
    }

    componentDidMount() {
        const { record, column } = this.props;
        this.setState({ value: record[column.dataIndex] })
    }

    componentWillReceiveProps(props) {
        if(props.record && props.column.calc) {
            const { record, column } = props;
            const value = column.calc(record, column);
            if(record[column.dataIndex] !== value) {
                record[column.dataIndex] = value;
                this.props.onChange && this.props.onChange(record)
            }
        }
    }

    handleDateChange = (date, event) => {
        this.setState({ 
            value: moment(date).format('DD.MM.YYYY') 
        }, () => this.handleBlur())
    }

    handleInputChange = (event) => {
        const { value } = event.target;
        const { record, column } = this.props;
        this.setState({ value: _.toNumber(value) ? _.toNumber(value) : value })
    }

    handleSelectChange = (event) => {
        const { record, column } = this.props;
        this.setState({ 
            value: event.target.value 
        }, () => this.handleBlur())        
    }

    handleBlur = () => {
        const { record, column } = this.props;
        const { value } = this.state;
        if(record[column.dataIndex] !== value) {
            record[column.dataIndex] = value;
            this.props.onChange && this.props.onChange(record)
        }
    }

    render() {
        const { record, column } = this.props;
        const { value } = this.state;

        if(column.calc) {
            return <div style={{ padding: 5, fontSize: 12, backgroundColor: '#F7F7F7' }}>
                    {column.calc(record, column)}
                </div>
        }

        if(column.date) {
            return <DatePicker onChange={this.handleDateChange} 
                selected={value ? moment(value, 'DD.MM.YYYY') : undefined}
                dateFormat={'DD.MM.YYYY'} 
            />
        }

        if(column.select) {
            return <select value={value} onChange={this.handleSelectChange}>
                <option value={''} hidden></option>
                {_.map(
                    column.select,
                    item => <option value={item} key={item}>{item}</option>
                )}
            </select>
        }

        return <Input value={value} onChange={this.handleInputChange}
            onBlur={this.handleBlur} style={{ width: '100%', padding: 5, fontSize: 12 }}
        />

    }
}

export default class VirtualTable extends Component {

    handleChange = (record) => {
        this.props.onChangeCell && this.props.onChangeCell(record.id, record);
    }

    handleChangeCalc = (record) => {
        this.props.onChangeCalc && this.props.onChangeCalc(record)
    }

    renderEditableCell(record, column) {
        return <input value={record[column.dataIndex]} 
            style={{ 
                width: '100%',
                outline: 'none',
                fontSize: 12,
                padding: 5
            }}
        />
    }

    renderBodyRows() {
        const { source, columns } = this.props;
        return _.map(
            source,
            record => (
                <tr key={record.id}>
                    {this.renderBodyCells(record)}
                </tr>
            )
        )
        // return _.map(
        //     source,
        //     (record, index) => {
        //         return <VirtualRow 
        //             key={record.id}
        //             index={index}
        //             columns={columns}
        //             onChange={this.handleChange} 
        //             onChangeCalc={this.handleChangeCalc}
        //         />
        //     }
        // )
    }

    renderBodyCells(record) {
        const { columns } = this.props;
        return _.map(
            columns,
            column => (
                <td key={column.dataIndex} style={{ minWidth: column.width }}>
                    <EditableCell 
                        record={record} 
                        column={column} 
                        onChange={this.handleChange} 
                        onChangeCalc={this.handleChangeCalc}
                    />
                </td>
            )
        )
    }

    renderHeaderCells() {
        const { columns } = this.props;
        return _.map(
            columns, 
            column => (
                <td key={column.dataIndex} style={{ minWidth: column.width, maxWidth: column.width }}>
                    <Tooltip title={column.calcDesc}>
                    {column.title}
                    </Tooltip>
                </td>
            )
        )
    }

    render() {
        const { loading, columns, source, summary } = this.props;
        return <div className={'vt'}>
            {loading && <div className={'vt-loader'} />}
            <div className={'vt-wrapper'}>
                <AutoSizer>
                {({ height, width }) => (
                    <div className={'vt-container'} style={{ width: width - 5, height }}>

                        <table border={1} className={'vt-table-head'}>
                            <thead>
                                <tr>
                                    {this.renderHeaderCells()}
                                </tr>
                                <SummaryRowByYear columns={columns} source={summary} />
                                <SummaryRow columns={columns} source={source} />
                            </thead>
                        </table>

                        <table border={1} className={'vt-table-body'}>
                            <tbody style={{ height: height - 106 }}>
                                {this.renderBodyRows()}
                            </tbody>
                        </table>

                    </div>
                )}
                </AutoSizer>
            </div>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/VirtualTable/VirtualTable.jsx